import styled from '@emotion/styled/macro'
import Button from 'react-bootstrap/Button'

import mediaQuery from 'share/utils/mediaQuery'

const StartBtn = styled(Button)`
  align-self: center;
  margin-bottom: 1.5rem;
  width: 340px;

  ${mediaQuery('mobile')} {
    align-self: stretch;
    width: auto;
  }
`

export { StartBtn }
